// extracted by mini-css-extract-plugin
export default {"content":"rJ-z","lookName":"sJ-z","shopTheLookContainer":"tJ-z","productContainer":"uJ-z","imageContainer":"vJ-z","mainImage":"wJ-z"};